export default __webpack_public_path__ + "static/awards-88cb1645040c851fc6aab42adfad1e21.png";